<template>
<el-dialog :title="dialog.title" :visible.sync="dialog.visible">
    <div class="dialog-body">
        <el-table :data="tableData" max-height="410">
            <el-table-column property="id" label="编号" width="80"></el-table-column>
            <el-table-column property="store.title" label="门店"></el-table-column>
            <el-table-column property="store.city" label="城市" width="160" align="center"></el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button @click="deleteFn(scope.$index,scope.row)" type="danger" size="mini">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="添加门店" :visible.sync="dialogFormVisible" width="26%" append-to-body>
            <el-form :model="ruleForm" ref="appendStoreForm">
                <el-form-item label="门店名称" :label-width="formLabelWidth">
                    <el-select v-model="ruleForm.promoter_store_id" placeholder="门店名称" filterable>
                        <el-option v-for="(item,index) in storeList" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序" :label-width="formLabelWidth">
                    <el-input v-model="ruleForm.sort" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="doAppend('appendStoreForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">关闭</el-button>
        <el-button type="primary" @click="showAppendStore()">添加</el-button>
    </span>
</el-dialog>
</template>

<script>
export default {
    data() {
        return {
            query: {
                promoter_platform_id: 0
            },
            dialog: {
                title: '门店管理',
                visible: false
            },
            dialogFormVisible: false,
            formLabelWidth: '100px',
            storeList: [],
            tableData: [],
            ruleForm: {
                promoter_platform_id: 0,
                promoter_store_id: '',
                sort: 0
            },
            rules: {
                store_id: [{
                    required: true,
                    message: '请选择门店',
                    trigger: 'change'
                }],
            }
        };
    },
    created() {
        this.getPickerData();
    },
    methods: {
        getTableData() { //获取表格列表
            let that = this;
            let url = '/api/promoter.store/index';
            this.loading = true;
            this.query.promoter_platform_id = this.ruleForm.promoter_platform_id;
            this.$post(url,this.query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.loading = false;
            });
        },
        showStoreList(options) {
            this.dialog.visible = true;
            this.ruleForm.promoter_platform_id = options.id
            this.getTableData();
        },
        getPickerData() {
            let that = this;
            let url = '/api/promoter.platform/picker';
            this.$post(url).then(function (response) {
                if (response.code == '200') {
                    that.storeList = response.data.storeList;
                } else {
                    this.$message(response.msg);
                }
            });

        },
        showAppendStore() {
            this.dialogFormVisible = true;
        },
        doAppend(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    let url = '';
                    url = '/api/promoter.store/create';
                    this.$post(url, this.ruleForm).then(function (response) {
                        if (response.code == '200') {
                            that.dialogFormVisible = false;
                            that.resetForm(formName);
                            that.getTableData();
                        } else {
                            that.$message(response.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
         deleteFn(index,e){
            let _this=this                       
            this.$confirm('此操作将, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                    let url = '/api/promoter.store/delete';
                    let query = {id:e.id};                    
                    this.loading = true;
                    this.$post(url, query).then(function (response) {
                        
                        if(response.code==200){
                            _this.tableData.splice(index,1)
                        }
                        _this.$message({
                            type: 'success',
                            message: response.msg
                        });
                        
                    });
               
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        }
    }

}
</script>
